import { render } from "./HeroiconsOutlineDocumentText.vue?vue&type=template&id=2dbfb0b0"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDocumentText.vue"]])

export default __exports__